module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.5.4@core-js/library/modules/_fails.js
// module id = 74
// module chunks = 0 1